<div class="tw-min-h-screen tw-bg-slate-50 tw-py-12 tw-px-4">
  <div class="tw-max-w-2xl tw-mx-auto">

    <div class="tw-mb-8">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">Contáctanos</h1>
      <p class="tw-mt-1 tw-text-slate-500 tw-text-sm">Envíanos un mensaje y te respondemos a la brevedad</p>
    </div>

    <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
      <form [formGroup]="formCont" (ngSubmit)="enviarContacto()">
        <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Nombre</label>
            <input type="text" name="nombre" id="nombre" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Nombre" formControlName="nombre">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCont.controls.nombre.errors && mostrarMensaje">
              <div *ngIf="formCont.controls.nombre.errors.required">El nombre es requerido.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Apellidos</label>
            <input type="text" name="apellidos" id="apellidos" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Apellidos" formControlName="apellidos">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCont.controls.apellidos.errors && mostrarMensaje">
              <div *ngIf="formCont.controls.apellidos.errors.required">Los apellidos son requeridos.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Correo</label>
            <input type="email" name="correo" id="correo" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="correo@ejemplo.com" formControlName="correo">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCont.controls.correo.errors && mostrarMensaje">
              <div *ngIf="formCont.controls.correo.errors.required">El correo es requerido.</div>
              <div *ngIf="formCont.controls.correo.errors.pattern">El correo no es válido.</div>
            </div>
          </div>

          <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Teléfono</label>
            <input type="text" name="telefono" id="telefono" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" placeholder="Teléfono" formControlName="telefono"
              (countryChange)="obtenerCodigoPais($event)">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCont.controls.telefono.errors && mostrarMensaje">
              <div *ngIf="formCont.controls.telefono.errors.required">El número del teléfono es requerido.</div>
              <div *ngIf="formCont.controls.telefono.errors.pattern">Deben ser solo números.</div>
              <div *ngIf="formCont.controls.telefono.errors.minlength">El número debe contener al menos 10 dígitos.</div>
              <div *ngIf="formCont.controls.telefono.errors.maxlength">El número debe contener máximo 12 dígitos.</div>
            </div>
          </div>

          <div class="sm:tw-col-span-2">
            <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Mensaje</label>
            <textarea name="mensaje" id="mensaje" class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-blue-400 tw-transition" rows="6" placeholder="¿Cómo podemos ayudarte?" formControlName="mensaje"></textarea>
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formCont.controls.mensaje.errors && mostrarMensaje">
              <div *ngIf="formCont.controls.mensaje.errors.required">El mensaje es requerido.</div>
            </div>
          </div>

          <div class="sm:tw-col-span-2">
            <ngx-recaptcha2 formControlName="recaptcha"
              (success)="handleSuccess($event)"
              (reset)="handleReset()"
              (expire)="handleExpire()"
              (load)="handleLoad()"
              [siteKey]="calveSitio"
              [size]="'normal'"
              [hl]="lang"></ngx-recaptcha2>
          </div>

          <div class="sm:tw-col-span-2" *ngIf="enviandoForm">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600">{{mensajeError}}</div>
          </div>

          <div class="sm:tw-col-span-2">
            <button type="submit" [disabled]="envioCorreo"
              class="tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-border-0 tw-cursor-pointer tw-transition"
              style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
              Enviar
            </button>
          </div>

          <div class="sm:tw-col-span-2" *ngIf="envioCorreo && mensajeExito">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-emerald-50 tw-border tw-border-emerald-200 tw-text-sm tw-text-emerald-700">{{ mensajeExito }}</div>
          </div>
          <div class="sm:tw-col-span-2" *ngIf="envioCorreo && mensajeError">
            <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600">{{ mensajeError }}</div>
          </div>

        </div>
      </form>
    </div>

    <div class="tw-mt-8 tw-rounded-2xl tw-overflow-hidden tw-border tw-border-slate-100" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.7793952793663!2d-99.1744351851432!3d19.421935386890308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff48dcb69ed7%3A0xc0ac4b068e8f67de!2sTec+Gurus+%40CDMX!5e0!3m2!1sen!2smx!4v1546714258787"
        class="tw-w-full tw-h-64 tw-block tw-border-0"></iframe>
    </div>

  </div>
</div>
